import {
  USER_LOADED,
  USER_LOADING,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
  PAGE_ERROR,
  LOGIN_2FA,
} from "../actions/types";

const initialState = {
  token: localStorage.getItem("token"),
  authToken: localStorage.getItem("authToken"),
  isAuthenticated: null,
  isLoading: false,
  user: null,
  authCode: null,
};

export default function AuthReducer(state = initialState, action) {
  switch (action.type) {
    case USER_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case USER_LOADED:
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("authToken", action.payload.token);
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        user: action.payload,
      };

    case AUTH_ERROR:
    case LOGIN_FAIL:
    case PAGE_ERROR:
    case LOGOUT_SUCCESS:
      localStorage.removeItem("token");
      localStorage.removeItem("authToken");
      return {
        ...state,
        token: null,
        user: null,
        isAuthenticated: false,
        isLoading: false,
      };

    case LOGIN_SUCCESS:
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("authToken", action.payload.token);
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        isLoading: false,
        user: action.payload,
      };

    case LOGIN_2FA:
      return {
        ...state,
        authCode: action.payload,
      };

    default:
      return state;
  }
}
